import {
    Autocomplete,
    FormControl,
    InputLabel,
    Select,
    TextField,
    Grid,
    MenuItem
  } from '@mui/material'
  import React from 'react'
  
  const PulseRhythm = ({ moduleValues, setModuleValues }) => (
    <Grid item xs={12} lg={4}>
       <FormControl fullWidth>
        <InputLabel>Pulse Rhythm</InputLabel>
        <Select
          value={moduleValues?.['Pulse Rhythm'] ?? ''}
          onChange={(e) =>setModuleValues(prev => ({...prev, ['Pulse Rhythm']: e.target.value}))
          }
          label="Pulse Rhythm"
        >
          <MenuItem value="Regular">Regular</MenuItem>
          <MenuItem value="Regularly Irregular">Regularly Irregular</MenuItem>
          <MenuItem value="Irregularly Irregular">Irregularly Irregular</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  )
  
  export default PulseRhythm
  